import React from 'react';
import { useIntl } from 'react-intl';
import PropTypes from 'prop-types';
import { DropdownMenu } from 'ui-components/components/dropdown-menu';
import { DropdownMenuItem } from 'ui-components/components/dropdown-menu-item';
import { DropdownMenuItemGroup } from 'ui-components/components/dropdown-menu-item-group';
import { DropdownMenuToggler } from 'ui-components/components/dropdown-menu-toggler';
import { MessageDescriptorPropType } from '../../../../prop-types/intl';
import messages from '../messages';
import style from '../style.module.less';
import { EMPTY_PACKAGE_ID } from '../../../../constants/services';
import { defaultInternationalPackageName, defaultPackageName } from '../formattedMessageConstants';
import { DropdownMenuType } from 'ui-components/components/dropdown-menu/dropdown-menu-type';

const renderPackages = (packages, onPackageChanged) => {
  return packages.map(({ id, name }) => {
    const [packageTypeId] = id.split('-');
    return (
      <DropdownMenuItem key={id} onClick={() => onPackageChanged(packageTypeId)}>
        {name}
      </DropdownMenuItem>
    );
  });
};

const renderPackageGroups = (packageGroups, intl, onPackageChanged) => {
  return packageGroups.map(({ id, name, packages }) => (
    <DropdownMenuItemGroup key={id} label={intl.formatMessage(name, name?.values)}>
      {renderPackages(packages, onPackageChanged)}
    </DropdownMenuItemGroup>
  ));
};

const PresetGroupPackageDropdown = ({
  selectedPackageName = '',
  packageGroups,
  onPackageChanged,
  isEnabled = false,
  isInternational = false,
}) => {
  const intl = useIntl();
  const defaultPackageText = isInternational ? defaultInternationalPackageName : defaultPackageName;
  const id = isInternational ? 'international-package' : 'domestic-package';
  return (
    <DropdownMenu
      ariaLabel={id}
      data-testid={id}
      disabled={!isEnabled}
      dropdownMenuShouldHaveWidthOfButton
      dropdownMenuType={DropdownMenuType.ComboBox}
      fullWidth
      id={id}
      title={selectedPackageName}
      variant='form'
    >
      <DropdownMenuToggler className={style['dropdown-picker']}>{selectedPackageName || defaultPackageText}</DropdownMenuToggler>
      <DropdownMenuItem onClick={() => onPackageChanged(EMPTY_PACKAGE_ID)}>
        {intl.formatMessage(messages.packageNoneOption)}
      </DropdownMenuItem>
      {renderPackageGroups(packageGroups, intl, onPackageChanged)}
    </DropdownMenu>
  );
};

PresetGroupPackageDropdown.propTypes = {
  selectedPackageName: PropTypes.string,
  packageGroups: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string,
      name: MessageDescriptorPropType,
      packages: PropTypes.arrayOf(
        PropTypes.shape({
          id: PropTypes.string,
          name: PropTypes.string,
        }),
      ),
    }),
  ).isRequired,
  isEnabled: PropTypes.bool,
  onPackageChanged: PropTypes.func.isRequired,
  isInternational: PropTypes.bool,
};

export default PresetGroupPackageDropdown;
